

import { Component, Suspense } from 'react';
import AnimatedRoutes from "./animatedRoutes";
class  App extends Component {
  
  render(){
  return (
    <div>
 <AnimatedRoutes></AnimatedRoutes>


 </div>

  )
}
}
export default App;
